import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { checklistData } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import { FiFilter, FiPlus } from 'react-icons/fi';

const Checklists = () => {
  const [filter, setFilter] = useState('All');
  const lanes = ['To Do', 'In Progress', 'In Review', 'Compliant', 'Gap Identified'];

  const getStatusColor = (status) => {
    switch(status) {
      case 'Compliant': return 'border-emerald-500/50 bg-emerald-500/10 text-emerald-400';
      case 'In Progress': return 'border-blue-500/50 bg-blue-500/10 text-blue-400';
      case 'In Review': return 'border-amber-500/50 bg-amber-500/10 text-amber-400';
      case 'Gap Identified': return 'border-red-500/50 bg-red-500/10 text-red-400';
      default: return 'border-slate-600 bg-slate-800 text-slate-300';
    }
  };

  return (
    <div className="h-full flex flex-col space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-slate-100">Framework Lanes</h1>
          <p className="text-slate-400 mt-1">Manage controls and track implementation progress.</p>
        </div>
        <div className="flex gap-3">
          <button className="flex items-center gap-2 px-4 py-2 bg-slate-800 border border-slate-700 rounded-lg text-slate-300 hover:bg-slate-700 transition-colors">
            <SafeIcon icon={FiFilter} /> Filter
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-amber-500 text-slate-900 rounded-lg hover:bg-amber-400 font-medium shadow-[0_0_10px_rgba(245,158,11,0.2)]">
            <SafeIcon icon={FiPlus} /> New Control
          </button>
        </div>
      </div>

      <div className="flex gap-2 pb-4 overflow-x-auto">
        {['All', 'SOC 2', 'ISO 27001', 'GDPR', 'HIPAA'].map(fw => (
          <button 
            key={fw}
            onClick={() => setFilter(fw)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium border transition-all ${
              filter === fw 
                ? 'bg-amber-500/20 border-amber-500/50 text-amber-400' 
                : 'bg-slate-800/50 border-slate-700 text-slate-400 hover:border-slate-500'
            }`}
          >
            {fw}
          </button>
        ))}
      </div>

      <div className="flex-1 flex gap-6 overflow-x-auto pb-4">
        {lanes.map((lane, index) => (
          <div key={lane} className="min-w-[300px] flex flex-col bg-slate-800/30 border border-slate-700/50 rounded-xl p-4">
            <h3 className="font-semibold text-slate-300 mb-4 flex items-center justify-between">
              {lane}
              <span className="text-xs bg-slate-700 px-2 py-0.5 rounded-full">
                {checklistData.filter(t => t.status === lane && (filter === 'All' || t.framework === filter)).length}
              </span>
            </h3>
            
            <div className="space-y-3 flex-1 overflow-y-auto pr-2 custom-scrollbar">
              {checklistData
                .filter(task => task.status === lane && (filter === 'All' || task.framework === filter))
                .map((task, i) => (
                  <motion.div 
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: i * 0.1 }}
                    key={task.id} 
                    className={`p-4 rounded-lg border bg-slate-900/50 shadow-sm cursor-pointer hover:shadow-md transition-all ${getStatusColor(task.status)}`}
                  >
                    <div className="flex justify-between items-start mb-2">
                      <span className="text-xs font-bold px-2 py-1 rounded bg-black/30 tracking-wider">
                        {task.framework} - {task.control}
                      </span>
                    </div>
                    <h4 className="text-sm font-medium text-slate-100 mb-3">{task.title}</h4>
                    <div className="flex justify-between items-center text-xs text-slate-400">
                      <span>Owner: {task.owner}</span>
                    </div>
                  </motion.div>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Checklists;